import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Close } from "@mui/icons-material";
import MDBox from "components/MDBox";

export const ModalContext = React.createContext({
  component: undefined,
  refresh: false,
  setComponent: () => {},
  show: () => {},
  hide: () => {},
  setAfterClose: () => {},
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  p: 4,
};
const ModalProvider = (props) => {
  const [isShow, setShow] = useState(false);
  const [modalComponent, setModalComponent] = useState();
  const [refresh, setRefresh] = useState(false);
  const show = () => {
    setShow(true);
  };

  const destroyModal = () => {
    setShow(false);
    setModalComponent(null);
  };

  const hide = () => {
    destroyModal();
    setRefresh(!refresh);
  };

  return (
    <ModalContext.Provider
      value={{
        setComponent: setModalComponent,
        component: modalComponent,
        hide,
        show,
        refresh,
      }}
    >
      {props.children}
      <Modal
        open={isShow}
        onClose={hide}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <MDBox display='flex' justifyContent='end' >
            <Close onClick={hide} sx={{cursor:'pointer',mt:-2,mr:-2}} />
          </MDBox>
          {modalComponent}
          </Box>
      </Modal>
    </ModalContext.Provider>
  );
};

export const ModalContextConsumer = ModalContext.Consumer;

export default ModalProvider;
